import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { usePaymentIntent } from '@/api/queries/payments';
import { TipTopPayWidget } from '@/components/payment/TipTopPayWidget';
import { Spinner } from '@/components/ui/Spinner';
import { paths } from '@/routes/paths';

export function PayIntentPage(): JSX.Element {
  const { t } = useTranslation();
  const { intentId = '' } = useParams<{ intentId: string }>();
  const navigate = useNavigate();
  const intentQuery = usePaymentIntent(intentId || null);
  const intent = intentQuery.data;

  useEffect(() => {
    if (!intent) {
      return;
    }
    if (intent.status === 'succeeded') {
      if (intent.purpose === 'subscription') {
        navigate(paths.subscribeSuccess, { replace: true });
        return;
      }
      navigate(paths.wallet, { replace: true });
      return;
    }
    if (intent.status === 'failed' || intent.status === 'cancelled' || intent.status === 'expired') {
      if (intent.purpose === 'subscription') {
        navigate(paths.subscribeError, { replace: true });
        return;
      }
      navigate(paths.walletTopup, { replace: true });
    }
  }, [intent, navigate]);

  if (intentQuery.isLoading || !intent) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spinner />
      </div>
    );
  }

  if (intent.widget_config) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16 }}>
        <p style={{ marginBottom: 16, textAlign: 'center' }}>
          {t('wallet.topup.open_checkout', { defaultValue: 'Complete payment in the form below' })}
        </p>
        <TipTopPayWidget
          config={intent.widget_config}
          onComplete={() => {
            void intentQuery.refetch().then(() => {
              window.location.href = `syron://payment/success?intent_id=${encodeURIComponent(intentId)}`;
            });
          }}
        />
      </div>
    );
  }

  if (intent.checkout_url) {
    window.location.href = intent.checkout_url;
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spinner />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16 }}>
      <p>{t('errors.generic')}</p>
    </div>
  );
}
